export default __webpack_public_path__ + "static/media/Jubilat-Bold.9f6952c3.otf";